import Vue from 'vue';
import Router from 'vue-router';

export default () => {
  Vue.use(Router);

  const router = new Router({
    mode: 'history',
    base: '/ics/property/building/',
    routes: [
      {
        path: '/',
        name: 'buildingIndex',
        component: () => import('./search'),
      },
      {
        path: '/details/:id',
        name: 'buildingDetail',
        component: () => import('./detail/Building'),
      },
      {
        path: '/details/:id/:buildingName',
        name: 'buildingDetailName',
        component: () => import('./detail/Building'),
      },
      {
        path: '/list/:sbu?',
        name: 'buildingList',
        component: () => import('./list'),
      },
    ],
    scrollBehavior() {
      return { x: 0, y: 0 };
    },
  });

  router.beforeEach((to, from, next) => {
    Vue.$gmapDefaultResizeBus.$emit('resize');
    next();
  });

  return router;
};
